<template>
  <div class="rights" v-loading="loading">
    <div class="resume-top">
      <div class="resume-top-left">
        <span
          :class="current === item.value ? 'rtl-select' : ''"
          v-for="item in options"
          :key="'tabs' + item.value"
          @click="switchTab(item.value)"
          >
           {{ item.label }}
          <template v-if="item.value === 5 && freeRight > 0">
            <el-badge :value="freeRight" :max="99" class="item"></el-badge>
          </template>
         
          </span>
      </div>
    </div>
    <company v-if="current === 1" />
    <record v-if="current === 2" :current="current" :key="current"/>
    <record v-if="current === 3" :current="current" :key="current"/>
    <record v-if="current === 4" :current="current" :key="current"/>
    <list v-if="current === 5" :current="current" :key="current"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import company from "./company";
import record from "./record";
import list from "./list";

export default {
  components: {
    company,
    record,
    list
  },
  data() {
    return {
      loading: false,
      current: 1,
      options: [
        {
          value: 1,
          label: "权益中心",
        },
        {
          value: 2,
          label: "购买记录",
        },
        {
          value: 3,
          label: "权益获得记录",
        },
        {
          value: 4,
          label: "权益使用记录",
        },
        {
          value: 5,
          label: "免费领权益",
        },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo","freeRight"]),
  },
  created() {
    //购买记录、权益获得记录、权益使用记录tab，仅当前登录账号为企业管理员角色可见 
    // v3.3.0 该tab修改为对全部账号角色开放
    // if (
    //   this.userInfo.company &&
    //   this.userInfo.company.company_employer.is_admin !== 1
    // ) {
    //   this.options = [...this.options.slice(0, 1),...this.options.slice(4, 5)];
    // }

    this.$bus.$on("updateRightsCurrent", (current) => {
        this.switchTab(current)
    });
  },
  mounted() {
   const {current} = this.$route.params;
  
   if(current){
     this.current = current*1;
   }
  },
  methods: {
    switchTab(value) {
      this.current = value;
     
    },
  },
};
</script>

<style lang='scss'>
@import "./index.scss";
</style>
